import { Component, OnInit } from '@angular/core';

/** state mgmt */
import { AppState } from 'src/app/store/app.state';
import { Store } from '@ngrx/store';

/** services */
import { ModalService } from 'src/app/services/modal.service';

/** actions */
import { verifyApplication } from 'src/app/store/actions/account.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';

@Component({
  selector: 'app-verify-master',
  templateUrl: './verify-master.component.html',
  styleUrls: ['./verify-master.component.scss']
})
export class VerifyMasterComponent implements OnInit {

  data!: any;

  constructor(
    private store: Store<AppState>,
    private modal: ModalService,
  ) { }

  ngOnInit(): void {

  }

  cancel (): void {
    this.modal.hideVerifyMaster();
  }

  verify (): void {
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(verifyApplication({uuid: this.data.id}));
    // this.modal.hideVerifyMaster();
  }
}
